import lazyLoading from './config';

export default [
    {
        path: '/control',
        name: 'control',
        meta: {
            title: '控制台',
            auth: true
        },
        redirect: '/control/app/list',
        component: resolve => lazyLoading(resolve, 'control'),
        children: [
            {
                name: 'control.app',
                path: 'app',
                meta: {
                    title: '应用管理'
                },
                redirect: '/control/app',
                component: resolve => lazyLoading(resolve, 'control/app'),
                children: [
                    {
                        name: 'control.app.list',
                        path: '/control/app/list',
                        meta: {
                            title: '应用列表',
                            isMenu: true
                        },
                        component: resolve =>
                            lazyLoading(resolve, 'control/app/list')
                    },
                    {
                        name: 'control.app.category',
                        path: '/control/app/category',
                        meta: {
                            title: '应用类目'
                        },
                        component: resolve =>
                            lazyLoading(resolve, 'control/app/category')
                    },
                    {
                        name: 'control.app.create',
                        path: '/control/app/create',
                        meta: {
                            title: '应用创建'
                        },
                        component: resolve =>
                            lazyLoading(resolve, 'control/app/create')
                    },
                    {
                        name: 'control.app.update',
                        path: '/control/app/update',
                        meta: {
                            title: '应用更新'
                        },
                        component: resolve =>
                            lazyLoading(resolve, 'control/app/create')
                    },
                    {
                        name: 'control.app.detail',
                        path: '/control/app/detail',
                        meta: {
                            title: '应用详情'
                        },
                        component: resolve =>
                            lazyLoading(resolve, 'control/app/detail')
                    }
                ]
            },
            {
                name: 'control.user',
                path: 'user',
                meta: {
                    title: '开发者个人中心'
                },
                redirect: '/control/user/baseInfo',
                component: resolve => lazyLoading(resolve, 'control/user'),
                children: [
                    {
                        name: 'control.user.baseInfo',
                        path: '/control/user/baseInfo',
                        meta: {
                            title: '基本信息',
                            isMenu: true
                        },
                        component: resolve =>
                            lazyLoading(resolve, 'control/user/baseInfo')
                    },
                    {
                        name: 'control.user.certification',
                        path: '/control/user/certification',
                        meta: {
                            title: '资质信息',
                            isMenu: true
                        },
                        component: resolve =>
                            lazyLoading(
                                resolve,
                                'control/user/certification/detail'
                            )
                    },
                    {
                        name: 'control.user.certification.edit',
                        path: '/control/user/certification/edit',
                        meta: {
                            title: '编辑资质信息',
                            isMenu: false
                        },
                        component: resolve =>
                            lazyLoading(
                                resolve,
                                'control/user/certification/edit'
                            )
                    },
                    {
                        name: 'control.user.certification.create',
                        path: '/control/user/certification/create',
                        meta: {
                            title: '选择开发者类型',
                            isMenu: false,
                            keepAlive: true
                        },
                        component: resolve =>
                            lazyLoading(
                                resolve,
                                'control/user/certification/create'
                            )
                    },
                    {
                        name: 'control.user.certification.provider',
                        path: '/control/user/certification/provider',
                        meta: {
                            title: '完善开发者信息-服务商',
                            isMenu: false
                        },
                        component: resolve =>
                            lazyLoading(
                                resolve,
                                'control/user/certification/edit'
                            )
                    },
                    {
                        name: 'control.user.certification.self',
                        path: '/control/user/certification/self',
                        meta: {
                            title: '完善开发者信息-自研',
                            isMenu: false
                        },
                        component: resolve =>
                            lazyLoading(
                                resolve,
                                'control/user/certification/edit'
                            )
                    }
                ]
            },
            {
                name: 'control.settle',
                path: 'settle',
                meta: {
                    title: '交易结算'
                },
                redirect: '/control/settle/order',
                component: resolve => lazyLoading(resolve, 'control/settle'),
                children: [
                    {
                        name: 'control.settle.order',
                        path: '/control/settle/order',
                        meta: {
                            title: '账单管理',
                            isMenu: true
                        },
                        component: resolve =>
                            lazyLoading(resolve, 'control/settle/order/list')
                    },
                    {
                        name: 'control.settle.order.detail',
                        path: '/control/settle/order/detail/:id',
                        meta: {
                            title: '对账单详情',
                            isMenu: false
                        },
                        component: resolve =>
                            lazyLoading(resolve, 'control/settle/order/detail')
                    }
                ]
            }
        ]
    }
];
